
import http from '@/features/shared/http/client';
import { CharacterGenerationRequest } from '@storyverse/shared';

export class CharacterAIService {
    async generateLookTestImage(request: CharacterGenerationRequest): Promise<{ imageUrl: string }> {
        const response = await http.post<{ success: boolean; imageUrl: string }>('/generateCharacterLookTest', request);
        return { imageUrl: response.data.imageUrl };
    }
}

export const characterAIService = new CharacterAIService();
